var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCommunications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.262,
    height: 125.047,
    viewBox: "0 0 145.262 125.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comunicazioni",
    transform: "translate(-124.326 -104.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37534",
    "data-name": "Tracciato 37534",
    d: "M293.358,117.926,162.491,166.37l24.058,11.921.006,0a2.268,2.268,0,0,1,1.252,1.829l7.13,39.222,12.474-22.244h0a2.27,2.27,0,0,1,3.695-.376l34.3,33.821,47.949-112.61Zm-10.134-1.083,13.376-4.952a2.269,2.269,0,0,1,2.99,2.972h0L248.337,235.219a2.272,2.272,0,0,1-3.741.879l0,0-34.686-34.2-14.041,25.039a2.269,2.269,0,0,1-4.267-.6l.007-.007-8.087-44.487-27.61-13.681a2.27,2.27,0,0,1,.077-4.228H156L283.223,116.84Z",
    transform: "translate(-30.185 -6.84)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37535",
    "data-name": "Tracciato 37535",
    d: "M233.057,178.381a2.265,2.265,0,1,0,2.3,3.9l111.956-66.344a2.266,2.266,0,0,0-2.3-3.9Z",
    transform: "translate(-78.85 -6.852)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37536",
    "data-name": "Tracciato 37536",
    d: "M388.064,115.637a2.264,2.264,0,1,0-3.12-3.28l-88.112,84.226a2.264,2.264,0,1,0,3.12,3.28Z",
    transform: "translate(-119.188 -6.858)",
    fill: "#b4b4b4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCommunications);
export default __webpack_public_path__ + "static/media/ic_communications.7fd213009e18020744a4be2ed8478da9.svg";
export { ForwardRef as ReactComponent };